/**
 * Componente que verifica si el usuario tiene al menos un restaurante
 * Si no tiene ninguno, lo redirige a crear uno
 */

import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { listRestaurants } from '../services/api';

function RequireRestaurant({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [hasRestaurants, setHasRestaurants] = useState(false);

  useEffect(() => {
    checkRestaurants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkRestaurants = async () => {
    try {
      // Si ya estamos en la página de crear restaurante, no verificar
      if (location.pathname === '/restaurant/new') {
        setHasRestaurants(true);
        setChecking(false);
        return;
      }

      const response = await listRestaurants();
      const restaurants = response.restaurants || [];

      console.log('[RequireRestaurant] Restaurantes encontrados:', restaurants.length);

      if (restaurants.length === 0) {
        console.log('[RequireRestaurant] Usuario sin restaurantes, redirigiendo a crear...');
        navigate('/restaurant/new', {
          state: {
            message: 'Bienvenido! Por favor crea tu primer restaurante para comenzar.',
          },
        });
        setHasRestaurants(false);
      } else {
        setHasRestaurants(true);
      }
    } catch (error) {
      console.error('[RequireRestaurant] Error verificando restaurantes:', error);
      // En caso de error, permitir continuar para no bloquear al usuario
      setHasRestaurants(true);
    } finally {
      setChecking(false);
    }
  };

  // Mientras verifica, mostrar loading o nada
  if (checking) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Cargando...</p>
      </div>
    );
  }

  // Si no tiene restaurantes y no estamos en /restaurant/new, no renderizar nada
  // (el navigate ya habrá redirigido)
  if (!hasRestaurants && location.pathname !== '/restaurant/new') {
    return null;
  }

  return children;
}

export default RequireRestaurant;
